import { render } from "./chartComponentForecast.vue?vue&type=template&id=4f9e00ad&scoped=true"
import script from "./chartComponentForecast.vue?vue&type=script&lang=js"
export * from "./chartComponentForecast.vue?vue&type=script&lang=js"

import "./chartComponentForecast.vue?vue&type=style&index=0&id=4f9e00ad&scoped=true&lang=css"

import exportComponent from "/home/manohar/Bhutan_gitlab/tethysapp-airqualitybt/tethysapp/airqualitybt/vairqualitybt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f9e00ad"]])

export default __exports__